import { IAsset } from '../domain/entities/Asset';

export const DEFAULT_IMAGE_ATTRIBUTE: IAsset = Object.freeze({
    src: '',
    alt: ''
});
